import { api } from "../../api";
import { CHANNEL_ENDPOINTS } from "../../../constants/endpoints";

export const videoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllChannels: builder.query({
      query: ({ page = 1, pageSize = 10, title = "" } = {}) => ({
        url: CHANNEL_ENDPOINTS.GET_ALL,
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ page, pageSize, title }).toString(),
      }),
      providesTags: ["Channel"],
    }),
    createChannel: builder.mutation({
      query: (channelData) => ({
        url: CHANNEL_ENDPOINTS.CREATE,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: channelData,
      }),
      invalidatesTags: ["Channel"],
    }),
    deleteChannel: builder.mutation({
      query: (id) => ({
        url: CHANNEL_ENDPOINTS.DELETE,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      }),
      invalidatesTags: ["Channel"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllChannelsQuery,
  useCreateChannelMutation,
  useDeleteChannelMutation,
} = videoApi;
